import { render } from "./LoaderAddl.vue?vue&type=template&id=4abb481e"
import script from "./LoaderAddl.vue?vue&type=script&lang=js"
export * from "./LoaderAddl.vue?vue&type=script&lang=js"

import "./LoaderAddl.vue?vue&type=style&index=0&id=4abb481e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__